import { lazy } from 'react'
import AuthGuard from '../guards/AuthGuard'
import RedirectPage from '../../views/Authentication/RedirectPage'
import { SUBJECTS, ACTIONS } from '../../utility/context/ability'

const Dashboard         = lazy(() => import('../../views/frtm/Dashboard'))
const RuleBuilder       = lazy(() => import('../../views/frtm/RuleBuilder'))
const Orchestration     = lazy(() => import('../../views/frtm/Orchestration'))
const Transactions      = lazy(() => import('../../views/frtm/Transactions'))
const Alerts            = lazy(() => import('../../views/frtm/Alerts'))
const Reports           = lazy(() => import('../../views/frtm/Reports'))
const Merchants         = lazy(() => import('../../views/frtm/Merchants'))
const AuditLog          = lazy(() => import('../../views/frtm/AuditLog'))
const Settings          = lazy(() => import('../../views/frtm/Settings'))
const Profile           = lazy(() => import('../../views/frtm/Profile'))
const TransactionDetail = lazy(() => import('../../views/frtm/TransactionDetail'))


// ── Rule engine pages ─────────────────────────────────────────────────────
const RuleManagement     = lazy(() => import('../../views/frtm/RuleManagement'))
const RuleDetail         = lazy(() => import('../../views/frtm/RuleDetail'))
const RuleVersionHistory = lazy(() => import('../../views/frtm/RuleVersionHistory'))
const RuleSandbox        = lazy(() => import('../../views/frtm/RuleSandbox'))

// ── Alert / analyst workflow pages ────────────────────────────────────────
const AlertDetail   = lazy(() => import('../../views/frtm/AlertDetail'))
const Investigation = lazy(() => import('../../views/frtm/Investigation'))

// ── Admin pages ───────────────────────────────────────────────────────────
const UserManagement = lazy(() => import('../../views/frtm/UserManagement'))
const RoleManagement = lazy(() => import('../../views/frtm/RoleManagement'))
const EntityListPage = lazy(() => import('../../views/frtm/EntityListPage'))

const g = (C, action, subject) => ({
  element: <AuthGuard component={C} action={action} subject={subject} />
})

const FrtmRoutes = [
  { path: '/redirect.html', element: <RedirectPage /> },
  // Original
  { path: '/dashboard',        ...g(Dashboard,         ACTIONS.READ,   SUBJECTS.DASHBOARD)     },
  { path: '/rule-builder',     ...g(RuleBuilder,       ACTIONS.READ,   SUBJECTS.RULE)          },
  { path: '/orchestration',    ...g(Orchestration,     ACTIONS.READ,   SUBJECTS.ORCHESTRATION) },
  { path: '/transactions',     ...g(Transactions,      ACTIONS.READ,   SUBJECTS.TRANSACTION)   },
  { path: '/transactions/:id', ...g(TransactionDetail, ACTIONS.READ,   SUBJECTS.TRANSACTION)   },
  { path: '/alerts',           ...g(Alerts,            ACTIONS.READ,   SUBJECTS.ALERT)         },
  { path: '/reports',          ...g(Reports,           ACTIONS.READ,   SUBJECTS.REPORT)        },
  { path: '/merchants',        ...g(Merchants,         ACTIONS.READ,   SUBJECTS.MERCHANT)      },
  { path: '/audit-log',        ...g(AuditLog,          ACTIONS.READ,   SUBJECTS.AUDIT_LOG)     },
  { path: '/settings',         ...g(Settings,          ACTIONS.READ,   SUBJECTS.SETTINGS)      },
  { path: '/profile',          ...g(Profile,           ACTIONS.READ,   SUBJECTS.PROFILE)       },

  // Rule engine
  { path: '/rule-management',       ...g(RuleManagement,     ACTIONS.READ,   SUBJECTS.RULE) },
  { path: '/rule-builder/new',      ...g(RuleBuilder,        ACTIONS.CREATE, SUBJECTS.RULE) },
  { path: '/rule-builder/:id/edit', ...g(RuleBuilder,        ACTIONS.UPDATE, SUBJECTS.RULE) },
  { path: '/rule-detail/:id',       ...g(RuleDetail,         ACTIONS.READ,   SUBJECTS.RULE) },
  { path: '/rule-versions/:id',     ...g(RuleVersionHistory, ACTIONS.READ,   SUBJECTS.RULE) },
  { path: '/rule-sandbox',          ...g(RuleSandbox,        ACTIONS.READ,   SUBJECTS.RULE) },

  // Alert workflow
  { path: '/alerts/:id',    ...g(AlertDetail,   ACTIONS.READ, SUBJECTS.ALERT) },
  { path: '/investigation', ...g(Investigation, ACTIONS.READ, SUBJECTS.ALERT) },

  // Admin
  { path: '/user-management', ...g(UserManagement, ACTIONS.READ, SUBJECTS.USER_MGMT || 'UserMgmt') },
  { path: '/role-management', ...g(RoleManagement, ACTIONS.READ, SUBJECTS.ROLE_MGMT || 'RoleMgmt') },
  { path: '/entity-lists', ...g(EntityListPage, ACTIONS.READ, SUBJECTS.ENTITY_LIST) },
]

export default FrtmRoutes